// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_j8-6";
export var emphasizeQuantity = "_j8-3";
export var flatBottomCorners = "_j8-5";
export var productImage = "_j8-0";
export var quantityContainer = "_j8-2";
export var tooltip = "_j8-1";
export var wrapAndEllipsesOverflow = "_j8-4";